import { ReactNode } from "react";
import "./SortByRadioButton.scss";
import { DesignTheme } from "../../../App.GeneratedEnums";
import { createSpreadableBem } from "../../../Helpers/createBem";

interface Props {
  description?: string;
  children: ReactNode | ReactNode[];
  theme?: DesignTheme;
}

const SortByRadioButton = ({ description, children, theme }: Props) => {
  const bem = createSpreadableBem("sort-by-radio-button");
  return (
    <fieldset {...bem("")}>
      <div {...bem("__row")}>
        <legend
          {...bem("__label", {
            "--theme-insight": theme === DesignTheme.Insight,
          })}
        >
          {description}
        </legend>
        <div {...bem("__options")}>{children}</div>
      </div>
    </fieldset>
  );
};

export default SortByRadioButton;
